module.exports = __webpack_public_path__ + "static/media/listcheck.c735da4c.svg";